import { createRouter, createWebHashHistory } from 'vue-router'
import pageRouter from '@/modules/page/router/index'

const routes = [
  {
    path: '/',
    ...pageRouter
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

export default router
